<template>
  <el-container class="login-page">
    <el-header>
      <h1>月亮湾</h1>
      <el-button class="register" plain>注册</el-button>
    </el-header>
    <el-main>
      <div class="box">
        <div class="main">
          <div class="left"><img src="../assets/pic_login.jpg" alt=""></div>
          <div class="right" v-if="type == 'forget'">
            <h3>欢迎使用月亮湾魔盒</h3>
            <h4>忘记密码</h4>
            <div class="row">
              <el-input placeholder="请输入手机号" v-model="phone">
                <!-- <template slot="prepend">+86</template> -->
                <el-input class="area_code" slot="prepend" v-model="area_code" :disabled="true"></el-input>
              </el-input>
            </div>
            <div class="row">
              <el-input placeholder="请输入验证码" v-model="code" class="">
                <el-button slot="append" :type="second <= 0 ? 'success' : 'info'" @click="getCode">{{ second <= 0 ? '发送验证码' : second + 's' }}</el-button>
              </el-input>
            </div>
            <el-button class="login" type="success" @click="toNew">重置密码</el-button>
            <div class="row">记起密码？<span class="green" @click="toLogin">立即登录</span></div>
          </div>
          <div class="right" v-else-if="type == 'new'">
            <h3>欢迎使用月亮湾魔盒</h3>
            <h4>设置新密码</h4>
            <div class="row">
              <div class="label">新密码</div>
              <el-input placeholder="请输入新密码" v-model="npsw" show-password></el-input>
            </div>
            <div class="row">
              <div class="label">确认新密码</div>
              <el-input placeholder="请再次输入新密码" v-model="apsw" show-password></el-input>
            </div>
            <el-button class="login" type="success" @click="toReset">重置密码</el-button>
          </div>
          <div class="right" v-else-if="type == 'choice'">
            <h3>欢迎使用月亮湾魔盒</h3>
            <div class="row">
              <el-radio-group v-model="choiceValue">
                <el-radio-button class="w50 h60" label="管理端"></el-radio-button>
                <el-radio-button class="w50 h60" label="客户端"></el-radio-button>
              </el-radio-group>
            </div>
            <div class="row" v-if="choiceValue == '客户端'">
              <el-select v-model="customerValue" placeholder="请选择客户">
                <el-option
                  v-for="item in customerOptions"
                  :key="item.client_id"
                  :label="item.client_name"
                  :value="item.client_id">
                </el-option>
              </el-select>
            </div>
            <el-button class="login" type="success" @click="choiceClick">确认</el-button>
          </div>
          <div class="right" v-else>
            <h3>欢迎使用月亮湾魔盒</h3>
            <h4></h4>
            <div class="row">
              <el-input placeholder="请输入手机号" v-model="phone">
                <!-- <template slot="prepend">+86</template> -->
                <el-input class="area_code" slot="prepend" v-model="area_code" :disabled="true"></el-input>
              </el-input>
            </div>
            <div class="row">
              <el-input placeholder="请输入密码" v-model="psw" show-password></el-input>
            </div>
            <el-row>
              <el-col :span="4" :offset="20">
                <el-link type="success" @click="toForget">忘记密码</el-link>
              </el-col>
            </el-row>
            <el-button class="login" type="success" @click="goLogin">登录</el-button>
          </div>
        </div>
      </div>
    </el-main>
  </el-container>
</template>
  
<script>
// user:13570997060
// psw:111111
let _ajaxType = 0

export default {
  name: 'Login',
  data() {
    return {
      type: '',
      choiceValue: '管理端',
      area_code: '86',
      phone: '',
      psw: '',
      npsw: '',
      apsw: '',
      code: '',
      code_r: '',
      customerOptions: [
        // {
        //   value: '客户A',
        //   label: '客户A',
        // },
        // {
        //   value: '客户B',
        //   label: '客户B',
        // },
        // {
        //   value: '客户C',
        //   label: '客户C',
        // }
      ],
      customerValue: '',
      second: 0
    }
  },
  mounted() {
    console.log(localStorage)
    const token = localStorage.getItem('sessionId');
    console.log('token', token)
    if (token) {
      this.type = 'choice'
      this.getClient()
    }
    const _phone = localStorage.getItem('phone');
    if(_phone){
      this.phone = _phone
    }
  },
  methods: {
    goLogin() {
      if(_ajaxType == 1) return
      _ajaxType = 1
      let _phone = this.phone
      let _psw = this.psw
      console.log(_phone, _psw)
      const _url = "/api/?mod=login"
      // console.log(_url)
      let loginData = {
        phone: _phone,
        password: _psw
      }
      this.axios.post(_url, loginData).then(json => {
        _ajaxType = 0
        // 获取
        let _data = json.data.data
        console.log("login", _data);
        if (json.data.errcode == 0) {
          localStorage.setItem('phone', _phone)
          localStorage.setItem('username', _data.username)
          localStorage.setItem('sessionId', _data.session_id)
          this.getClient()
          this.getUser()
          this.type = 'choice'
        }
        console.log(json.data);
      })
    },
    getClient() {
      const _url = "/api/?mod=client&action=all"
      // console.log(_url)
      this.axios.post(_url).then(json => {
        // 获取
        let _data = json.data.data
        console.log("clientData", _data);
        if (json.data.errcode == 0) {
          this.customerOptions = _data.result
          // localStorage.setItem('phone', _phone)
          // localStorage.setItem('sessionId', _data.session_id)
          // this.type = 'choice'
        }
        console.log(json.data);
      })
    },
    getUser() {
      const _url = "/api/?mod=user"
      // console.log(_url)
      this.axios.post(_url).then(json => {
        // 获取
        let _data = json.data.data
        console.log("checklogin", _data);
        if(_data.login == 1){
          this.global.money = _data.user.money
          console.log('user', this.global)
          return
        }
        localStorage.removeItem('sessionId');
        if(_path != '/login'){
          this.$router.replace('/login')
          // window.location.href = '/login'
        }
        console.log(json.data);
      })
    },
    choiceClick() {
      let _type = this.choiceValue
      if(_type == '管理端'){
        this.global.type = 'manage'
        this.$router.replace('/')
      }
      if(_type == '客户端'){
        let _client_id = this.customerValue
        console.log('client_id', _client_id)
        this.global.type = 'client'
        this.global.clientId = _client_id
        let _client = this.customerOptions.find(c => c.client_id === _client_id);
        console.log(_client)
        this.global.clientName = _client.client_name
        console.log(this.global)
        this.$router.replace('/client')
      }
    },
    toForget() {
      this.type = 'forget'
    },
    toNew() {
      if(_ajaxType == 1) return
      _ajaxType = 1
      let _phone = this.phone
      let _code = this.code
      // console.log(_phone, _psw)
      const _url = "/api/?mod=user&action=verify"
      // console.log(_url)
      let loginData = {
        phone: _phone,
        vcode: _code
      }
      this.axios.post(_url, loginData).then(json => {
        _ajaxType = 0
        // 获取
        let _data = json.data.data
        console.log("login", _data);
        if (json.data.errcode == 0) {
          this.code_r = _data.code
          this.type = 'new'
        }
        console.log(json.data);
      })
    },
    toLogin() {
      this.type = ''
    },
    getCode() {
      if(_ajaxType == 1) return
      let _second = this.second
      if(_second > 0) return
      _ajaxType = 1
      let _this = this
      let _phone = this.phone
      const _url = "/api/?mod=send"
      // console.log(_url)
      let loginData = {
        phone: _phone,
      }
      this.axios.post(_url, loginData).then(json => {
        // 获取
        let _data = json.data.data
        console.log("login", _data);
        if (json.data.errcode == 0) {
          this.$message({
            message: '发送验证码成功',
            type: 'success',
            offset: 300,
            onClose: function() {
              _ajaxType = 0
              _this.second = 61
              _this.waitCode()
            }
          });
        }else{
          _ajaxType = 0
        }
        console.log(json.data);
      })
    },
    waitCode(){
      let _second = this.second - 1
      this.second = _second
      if(_second <= 0){
        return
      }
      // 发送验证码
      setTimeout(this.waitCode, 1000)
    },
    toReset() {
      if(_ajaxType == 1) return
      _ajaxType = 1
      let _this = this
      let _phone = this.phone
      let _code = this.code_r
      let _npsw = this.npsw
      let _apsw = this.apsw
      console.log(_phone, _npsw)
      const _url = "/api/?mod=user&action=reset"
      // console.log(_url)
      let loginData = {
        phone: _phone,
        code: _code,
        password: _npsw,
        cfm_password: _apsw
      }
      this.axios.post(_url, loginData).then(json => {
        // 获取
        let _data = json.data.data
        console.log("login", _data);
        if (json.data.errcode == 0) {
          this.$message({
            message: '重置成功',
            type: 'success',
            offset: 300,
            onClose: function() {
              _ajaxType = 0
              _this.type = ''
            }
          });
        }else{
          _ajaxType = 0
        }
        console.log(json.data);
      })
    }
  }
}
</script>
  
<style scoped lang="less">
h1 {
  height: 60px;
  line-height: 60px;
  font-size: 24px;
  font-weight: normal;
}

.register {
  position: absolute;
  top: 50%;
  margin-top: -20px;
  right: 20px;
}

.box {
  text-align: center;
  margin-top: 60px;
  .main {
    position: relative;
    display: inline-block;
    width: 1000px;
    height: 596px;
    padding-left: 510px;
    padding-right: 80px;
    box-sizing: border-box;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 6px 0px;
    .left {
      position: absolute;
      top: 0;
      left: 0;
      width: 448px;
      height: 100%;
      img {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
      }
    }
    .right {
      width: 100%;
      height: 100%;
      h3 {
        height: 40px;
        margin-top: 30px;
        margin-bottom: 40px;
        color: rgba(80,184,92,1);
        font-size: 36px;
        line-height: 40px;
        font-weight: 400;
        text-align: left;
      }
      h4 {
        font-size: 24px;
      }
      .row {
        margin-top: 20px;
        .label {
          margin-bottom: 8px;
          text-align: left;
          font-weight: 600;
        }
        .area_code {
          position: relative;
          width: 80px;
          &::before {
            position: absolute;
            content: '+';
            top: 0;
            left: 28px;
            color: #606266;
            font-size: 14px;
            line-height: 59px;
            opacity: 0.4;
          }
        }
        .el-radio-group {
          width: 100%;
        }
        .w50 {
          width: 50%;
        }
        .h60 {
          height: 60px;
        }
      }
      .el-row {
        margin-top: 10px;
      }
      .el-select {
        width: 100%;
      }
      .login {
        width: 100%;
        margin-top: 20px;
      }
    }
  }
}

.el-input-group__append button.el-button {
  height: 58px;
  // color: rgb(10, 92, 10);
  // background-color: rgb(215, 247, 219);
  // border-color: rgb(215, 247, 219);
}
</style>


// WEBPACK FOOTER //
// src/views/Login.vue